import { bus } from '../core/event-bus.js';
import { buildSessionReport } from '../core/report-builder.js';
import { store } from '../core/state-store.js';
import { el } from '../utils/dom.js';

export function initDiagnosticsPanel() {
  const statusEl = document.getElementById('diagnostics-status');
  const logEl = document.getElementById('diagnostics-log');

  if (!statusEl || !logEl) return;

  const render = () => _renderDiagnostics(statusEl, logEl);

  bus.on('ad:event', render);
  bus.on('validation:completed', render);

  bus.on('session:started', () => {
    statusEl.textContent = 'Diagnostics in progress...';
    logEl.innerHTML = '<p class="placeholder-text">Diagnostics will appear after ad activity.</p>';
  });
  bus.on('session:reset', () => {
    statusEl.textContent = 'No diagnostics yet';
    statusEl.style.color = '';
    logEl.innerHTML = '<p class="placeholder-text">Diagnostics will appear after ad activity.</p>';
  });
}

function _renderDiagnostics(statusEl, logEl) {
  const report = buildSessionReport();
  const diagnostics = report.diagnostics;
  const issueCount = diagnostics.summary.error + diagnostics.summary.warning;

  store.update({ diagnosticsCount: issueCount });

  statusEl.textContent = `${diagnostics.summary.error} errors, ${diagnostics.summary.warning} warnings, ${diagnostics.summary.info} info`;
  statusEl.style.color = diagnostics.summary.error > 0
    ? 'var(--red)'
    : diagnostics.summary.warning > 0
      ? 'var(--orange)'
      : 'var(--green)';

  logEl.innerHTML = '';

  for (const issue of diagnostics.issues) {
    const row = el('div', {
      className: `diagnostic-entry severity-${issue.severity}`,
      'data-testid': `diagnostic-${issue.code}`,
    }, [
      el('span', { className: 'diagnostic-severity', textContent: issue.severity.toUpperCase() }),
      el('span', { className: 'diagnostic-message', textContent: issue.message }),
      el('span', { className: 'diagnostic-code', textContent: issue.code }),
    ]);
    logEl.appendChild(row);
  }
}
